import * as R from "ramda";
import { useState } from "react";
import {
  filterRolesByIds,
  getFullPermissionRoleIds,
  isRoleWithFullPermissions,
} from "common/functions/roles";
import { Role } from "common/types/roles";
import { VerticalField } from "common/ui/field";
import { createList } from "common/widgets/fancy-checkbox/list";
import { YesNo } from "common/widgets/radio-button-list/yes-no";
import { ValueProps } from "common/with-value-for";

interface PropTypes extends ValueProps<number[]> {
  label: string;
  roles?: Role[];
}

const List = createList<Role>();

export const RestrictToRoles = (props: PropTypes) => {
  const { label, roles = [], value = [] } = props;
  const [isRestricted, setIsRestricted] = useState<boolean>(value.length > 0);

  const onChange = (value: Role[]) => {
    const { onChange } = props;
    const roleIds = (value || []).map((r) => r.id);
    onChange(roleIds);
  };

  const onToggle = (isRestricted: boolean) => {
    const { onChange } = props;
    setIsRestricted(isRestricted);
    onChange(isRestricted ? getFullPermissionRoleIds(roles) : []);
  };

  const roleInput = (
    <List
      display={R.prop("name")}
      isDisabled={isRoleWithFullPermissions}
      items={roles}
      value={filterRolesByIds(roles, value)}
      onChange={onChange}
    />
  );

  if (roles.length === 0) return null;
  return (
    <div className="qa-restrict-to-roles">
      <VerticalField
        label={label}
        input={
          <YesNo name="isRestricted" onChange={onToggle} value={isRestricted} />
        }
      />
      {isRestricted ? (
        <VerticalField
          label={_("Select one or more roles")}
          input={roleInput}
        />
      ) : undefined}
    </div>
  );
};
